/* eslint import/no-extraneous-dependencies: "off" */
import { observer } from "mobx-react-lite";
import { PickerRef } from "rc-picker";
import * as React from "react";
import { DatePickerString } from "src/components/DatePickerString";
import {
  ActivateCallback,
  useActivateCallback,
} from "src/types/ActivateCallback";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrDatePicker } from "./ZAttrComponent";

type PropsAttrDatePicker = {
  attrMeta: ZAttrMeta;
  value: unknown;
  onChange?(newValue: unknown): void;
  disabled?: boolean;
  activateCallback?: ActivateCallback;
  component?: ZAttrDatePicker;
  textCvt?(text: string): string;
  onBlur: () => void;
};

export const AttrDatePicker: React.FC<PropsAttrDatePicker> = observer(
  (props) => {
    const {
      attrMeta,
      value,
      onChange,
      disabled,
      activateCallback,
      component,
      textCvt,
      onBlur,
    } = props;
    const dref = useActivateCallback<PickerRef>(
      activateCallback,
      (ref) => () => ref?.focus(),
    );
    const dateOnly =
      attrMeta.type.name === "dateTime" ? attrMeta.type.dateOnly : false;

    const cvt = (text: string | null | undefined) => {
      if (!text) return undefined;
      return textCvt?.(text) ?? text;
    };
    const handleChange = (newValue: unknown) => {
      // выяснилось, что бэк не может принять отсутствие атрибута. поэтому вместо undefined надо слать null
      onChange?.(newValue === undefined ? null : newValue);
    };

    return (
      <DatePickerString
        ref={dref}
        style={{ width: "100%" }}
        allowClear
        value={value as string}
        onChange={handleChange}
        disabled={disabled}
        showTime={!dateOnly}
        prefix={cvt(component?.prefix)}
        suffixIcon={cvt(component?.suffix)}
        placement={component?.placement}
        onBlur={onBlur}
      />
    );
  },
);
